// removed by extract-text-webpack-plugin
module.exports = {"direction_labels":"direction_labels__34ZlS","outline":"outline__34vUN","current_speed":"current_speed__5glIw","direction_arrow":"direction_arrow__VMS4I"};


//////////////////
// WEBPACK FOOTER
// ./components/wind-gauge/style.scss
// module id = wPJI
// module chunks = 0